import { NavigateFunction } from 'react-router-dom';
import { getOnboardingPath, OnboardingPages, Pages } from '../../../common/src/pages.ts';
import { localStorageGet, LocalStorageKey } from '../data/client_local_storage.ts';
import { getUrlForPage } from './path.ts';

// Whether Back has somewhere to go inside the app. React Router numbers the history entries it
// creates in this tab (history.state.idx), starting at 0 for the first one, and keeps the number
// across reloads. The browser's own history.length is no help: it also counts other sites' pages
// and never shrinks. idx is React Router's internal state, not public API, so go_back.test.ts pins
// the behavior this relies on.
export function canGoBackInApp(): boolean {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}

// The app's back buttons. With nowhere to go back to (a link opened in a new tab, or a first
// arrival from another site), Back leads to the Church tab for a household and to the demo for a
// visitor without one, replacing the current entry so Back from there does not return here.
export async function goBack(navigate: NavigateFunction) {
  if (canGoBackInApp()) {
    await navigate(-1);
    return;
  }
  const household = localStorageGet(LocalStorageKey.Household);
  await navigate(household ? getUrlForPage(Pages.Organization) : getOnboardingPath(OnboardingPages.Demo), {
    replace: true,
  });
}
